import { TooltipTrigger } from '@toggle/design-system';
import { startOfDay, subWeeks } from 'date-fns';
import React, { useMemo } from 'react';

import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';
import { useFilteredInsights } from '~/react-query-hooks/insights/useFilteredInsights';
import { ClickableScenarioInsightTooltip } from '~/views/dashboard/my-assets-widget/assets-table/insights-cell/clickable-scenario-insight-tooltip/ClickableScenarioInsightTooltip';
import { InsightsIcon } from '~/views/dashboard/my-assets-widget/assets-table/insights-cell/insights-icon/InsightsIcon';

import * as S from './RevampCompetitorsSection.styles';

const MAX_SCENARIOS = 3;

export interface CompetitorScenariosCellProps {
  entityTag: string;
}

export const CompetitorScenariosCell = ({
  entityTag,
}: CompetitorScenariosCellProps) => {
  const fromDate = useMemo(() => startOfDay(subWeeks(new Date(), 1)), []);

  const { data, isFetching } = useFilteredInsights({
    entity: [entityTag],
    from_date: fromDate,
  });

  if (isFetching) {
    return <S.StyledSkeletonLoader />;
  }

  const scenarioInsights = data?.data?.result ?? [];
  const exceedsMaxScenarios = scenarioInsights.length > MAX_SCENARIOS;

  const visibleScenarioInsights = scenarioInsights.slice(0, MAX_SCENARIOS);

  const remainingScenarioInsights = exceedsMaxScenarios
    ? scenarioInsights.slice(MAX_SCENARIOS)
    : [];

  return (
    <S.InsightsContainer>
      {visibleScenarioInsights.map(insight => (
        <InsightsIcon
          key={insight.id}
          insight={insight}
          isDisabled={false}
          variant="assets-table"
        />
      ))}
      {!!remainingScenarioInsights.length && (
        <TooltipContainer
          label={
            <ClickableScenarioInsightTooltip
              insights={remainingScenarioInsights}
              entityTag={entityTag}
            />
          }
          inPortal
          trigger={[TooltipTrigger.Hover]}
          placement="top-end"
          withSafePolygon
        >
          <S.InsightCount>+{remainingScenarioInsights.length}</S.InsightCount>
        </TooltipContainer>
      )}
    </S.InsightsContainer>
  );
};
